const featureKey = window.location.href.includes('f0810-vp1-m0.ka.serviceprobe.de')
  ? 'mmm-1740-header'
  : 'mmm-1598-header';

export type THeaderConfig = {
  title: string;
  text: string;
  link: string;
  image: {
    preview: string;
    live: string;
  };
  selector: string;
  alt: string;
  ariaLabel: string;
  label: string;
};

export type TConfig = {
  searchtarget: string;
  teaser: THeaderConfig[];
};

class NavTeaserService {
  private initPromiseRef: Promise<void>;

  public headerConfig: TConfig | null = null;
  public teaserConfig: Record<string, THeaderConfig> = {};

  constructor() {
    this.initPromiseRef = this.initService();
  }

  public async initService() {
    const features = await window.publicApi.getFeatures();
    const headerFeature = features.find(f => f.id === featureKey);
    this.headerConfig = (headerFeature?.config as TConfig) || [];
    if (this.headerConfig.teaser && this.headerConfig.teaser.length > 0) {
      this.headerConfig.teaser.forEach(c => (this.teaserConfig[c.selector] = c));
    }
  }

  public async whenReady() {
    return this.initPromiseRef;
  }
}

const navTeaserServiceInstance = new NavTeaserService();
export { navTeaserServiceInstance as NavTeaserService };
